module.exports = {"360482001":"茶山街道","360482100":"甘露镇","360482101":"江益镇","360482200":"金湖乡","360482201":"苏家垱乡","360482202":"泽泉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360482.json
// module id = 1390
// module chunks = 0